import wixWindow from 'wix-window';
import wixLocation from 'wix-location';
import wixSeo from 'wix-seo';
import { sendBi } from 'public/biModule';
import { getAllDataBack } from 'backend/examples.jsw';
import { session } from 'wix-storage';

const MOBILE = wixWindow.formFactor === 'Mobile';
const LIMIT_PER_PAGE = 12;
const BLACK = 'black';
const GREY = 'grey';

let category = 'all';
let level = 'all';
let search = '';
let sort = 'date';
let currentPage = 1;
let data = [];
let currentData = [];
let categoryButtons;
let today;

$w.onReady(async function () {

    // dropped as this BI event is sent from the masterpage
    // sendBi(129, {
    //     'category': 'example',
    //     'page_name': 'main_examples_page',
    //     'referral_url': wixWindow.referrer
    // });

    setSEO();
    wixLocation.onChange(initPage);

    $w('#repeaterExamples').data = [];

    $w('#paginationRepeater').onItemReady(paginationOnReadyRepeater);
    $w('#repeaterExamples').onItemReady(examplesOnReadyRepeater);

    today = new Date().getTime();
    checkMobile();

    $w('#repeaterExamples').hide();
    $w("#preloader").show();

    setGlobalVarsFromQueryParams();

    // Getting data with .then anotaiton. 
    // According to a recent SEO review, this performed worse than using async-await anotation.
    // getAllData().then(res => {
    //     $w("#preloader").hide();
    //     initPage();
    //     $w('#repeaterExamples').show();
    // });

    await getAllData()
    $w("#preloader").hide();
    initPage();
    $w('#repeaterExamples').show();
});

function initPage() {
    setGlobalVarsFromQueryParams();
    filterExamples();
    updateLevel();
    updateSort();
    if (!MOBILE) { updateCategory(); }
    updateSearch();
    setPagination();
}

function setSEO() {
    wixSeo.setMetaTags(
        [{
                'name': 'description',
                'content': 'Velo by Wix Examples - Explore example sites depicting different capabilities of using Velo. Aim for developers on all expertise levels.'
            },
            {
                'property': 'og:description',
                'content': 'Velo by Wix Examples - Explore example sites depicting different capabilities of using Velo. Aim for developers on all expertise levels.'
            }
        ]
    );

    wixSeo.setLinks(
        [{
            'rel': 'canonical',
            'href': 'https://www.wix.com/velo/examples'
        }]
    );
}

function checkMobile() {
    if (MOBILE) {
        // $w('#boxSearchMobile').collapse();
    } else {
        categoryButtons = [{ element: $w('#buttonAll'), name: 'all', biTopic: 'all_examples' },
            { element: $w('#buttonThirdParty'), name: 'integrations', biTopic: 'integrations' },
            { element: $w('#buttonBlog'), name: 'blog', biTopic: 'wix_blog' },
            { element: $w('#buttonBookings'), name: 'bookings', biTopic: 'wix_bookings' },
            { element: $w('#buttonStores'), name: 'stores', biTopic: 'wix_stores' },
            { element: $w('#buttonData'), name: 'data', biTopic: 'data' },
            { element: $w('#buttonInteractions'), name: 'interactions', biTopic: 'interactions' }
        ];

        categoryButtons.forEach((button) => {
            button.element.onClick(() => categoryClick(button.name, button.biTopic));
        })
    }
}

function setGlobalVarsFromQueryParams() {
    if (!hasQueryParamsInURL()) { // query params are not part of the URL, so try to restore them from session storage
        setQueryParamsInURLFromSessionStorage();
    }

    currentPage = wixLocation.query.page ? Number(wixLocation.query.page) : 1;
    level = wixLocation.query.level ? wixLocation.query.level : level;
    search = wixLocation.query.search ? wixLocation.query.search : search;
    category = wixLocation.query.category ? wixLocation.query.category : category;
    sort = wixLocation.query.sort ? wixLocation.query.sort : sort;
}

function hasQueryParamsInURL() {
    return Object.keys(wixLocation.query).filter((key) => {
        return key === 'page' || key === 'level' || key === 'search' || key === 'category' || key === 'sort'
    }).length > 0;
}

function setQueryParamsInURLFromSessionStorage() {
    const queryParamPartInURL = session.getItem('queryParamPartInURL');
    session.clear();
    if (queryParamPartInURL) wixLocation.to('/examples?' + queryParamPartInURL);
}

export function navigateToExample(url) {
    storeState();
    wixLocation.to(url);
}

function storeState() {
    const queryParamPartInURL = wixLocation.url.split('?')[1];
    if (queryParamPartInURL) session.setItem('queryParamPartInURL', queryParamPartInURL);
}

function filterExamples() {

    currentData = data;

    if (category !== 'all') {
        currentData = currentData.filter(item => {
            return (item.category.title === category)
        })
    }

    if (level !== 'all') {
        currentData = currentData.filter(item => {
            return (item.level.title === level)
        })
    }

    if (sort === 'views') {
        currentData.sort(function (a, b) {
            return b.exampleViews.views - a.exampleViews.views;
        });
    }

    if (sort === 'date') {
        currentData.sort(function (a, b) {
            return b.date - a.date;
        });
    }

    if (search !== '') {
        currentData = currentData.filter(item => {
            const keywordFound = (item.searchKeywords ? item.searchKeywords.toLowerCase().includes(search.toLowerCase()) : false)
            return (item.title.toLowerCase().includes(search.toLowerCase()) || (item.description.toLowerCase().includes(search.toLowerCase())) ||
                (keywordFound));
        });

        sendBi(194, {
            'category': 'example',
            'text': search,
            'topic': category,
            'level': level,
            'num_of_results': currentData.length,
            'referral_url': wixWindow.referrer
        });
    }

    if (currentData.length === 0) {
        $w('#repeaterExamples').hide();
        if (level === 'all') {
            $w('#noItemsFound').html = '<p>No items found. You can request an example <a href="https://www.wix.com/velo/request-a-resource?example=true" target="_self"><u style="color:blue;">here</u></a>.</p>';
        } else {
            $w('#noItemsFound').html = '<p>No items found for ' + level + '. You can request an example <a href="https://www.wix.com/velo/request-a-resource?example=true" target="_self"><u style="color:blue;">here</u></a>.</p>';
        }
        $w('#noItemsFound').show();
    } else {
        $w('#noItemsFound').hide();
        // $w('#repeaterExamples').data = conurrentData;
        $w('#repeaterExamples').show();
    }
}

export function updateLevel() {
    $w('#dropdownLevel').value = level;
}

export function updateSort() {
    $w('#dropdownSort').value = sort;
}

function updateCategory() {
    const buttonCategoryMapping = {
        integrations: 'buttonThirdParty',
        blog: 'buttonBlog',
        bookings: 'buttonBookings',
        stores: 'buttonStores',
        data: 'buttonData',
        interactions: 'buttonInteractions',
        all: 'buttonAll'
    }

    categoryButtons.forEach(button => {
        if (button.element.id === buttonCategoryMapping[category]) {
            button.element.disable();
            return;
        }
        button.element.enable();
    })
}

function updateSearch() {
    $w('#inputSearch').value = search;
    if (search !== '') {
        hideSearchIcon();
    }
}

function setPagination() {
    const newStart = (currentPage - 1) * LIMIT_PER_PAGE;
    $w('#repeaterExamples').data = currentData.slice(newStart, newStart + LIMIT_PER_PAGE);

    // BASEURL CHANGE Fix
    // const locationPath = wixLocation.path.join('/');
    const locationPath = 'examples';
    // const locationPath = 'https://www.wix.com/velo/examples';

    const paginationData = [];
    let totalPages = Math.ceil(currentData.length / LIMIT_PER_PAGE);

    if (totalPages !== 0) {

        let queryParamsString = createQueryParamsString();
        for (let index = 0; index < totalPages; index++) {
            const isFirstPage = index + 1 === 1;
            let link = locationPath;

            if (queryParamsString) {
                link += `?${queryParamsString}`
            }

            if (!isFirstPage) {
                let pageNumberQuery = `page=${index + 1}`;
                link += queryParamsString ? '&' + pageNumberQuery : '?' + pageNumberQuery;
            }

            paginationData.push({
                _id: index + 1 + '',
                isCurrentPage: currentPage === (index + 1),
                pageNumber: index + 1,
                link
            })
        }

        // const newStart = (currentPage - 1) * LIMIT_PER_PAGE;
        let rightArrowLink = '';
        let leftArrowLink = '';

        // $w('#repeaterExamples').data = currentData.slice(newStart, newStart + LIMIT_PER_PAGE);
        if (currentPage === 1) {
            $w('#leftArrow').hide();
        } else {
            // leftArrowLink = leftArrowLink + paginationData[currentPage - 2].link;
            leftArrowLink = paginationData[currentPage - 2].link;
            $w('#leftArrow').show();
            // BASEURL CHANGE Fix
            //$w('#leftArrow').link = 'https://www.wix.com/' + leftArrowLink;
            $w('#leftArrow').link = 'https://www.wix.com/velo/' + leftArrowLink;
            $w('#leftArrow').target = '_self';
        }

        if (currentPage === paginationData.length) {
            $w('#rightArrow').hide();
        } else {
            rightArrowLink = paginationData[currentPage].link;
            $w('#rightArrow').show();
            // BASEURL CHANGE Fix
            //$w('#rightArrow').link = 'https://www.wix.com/' + rightArrowLink;
            $w('#rightArrow').link = 'https://www.wix.com/velo/' + rightArrowLink;
            $w('#rightArrow').target = '_self';
        }

        $w('#paginationRepeater').data = []; // set an empty array to retrigger repeater on item ready event handler, probably a bug as it does not work without it
        $w('#paginationRepeater').data = paginationData;
        $w('#paginationRepeater').show();
    } else {
        $w('#paginationRepeater').hide();
    }
}

function createQueryParamsString() {
    const paramsArray = [];
    if (level !== 'all') {
        paramsArray.push(`level=${level}`);
    }
    if (category !== 'all') {
        paramsArray.push(`category=${category}`);
    }
    if (search !== '') {
        paramsArray.push(`search=${search}`);
    }
    if (sort !== 'date') {
        paramsArray.push(`sort=${sort}`);
    }
    return paramsArray.join('&');
}

export function updateQueryParams() {
    const myQuerys = createQueryParamsString();
    if (myQuerys) {
        wixLocation.to(`/examples?${myQuerys}`);
    } else {
        // wixLocation.to('https://www.wix.com/velo/examples');
        wixLocation.to('/examples');
    }
}

async function getAllData() {
    data = await getAllDataBack();
}

function categoryClick(clickedCategory, biTopic) {

    sendBi(196, {
        'category': 'example',
        'topic': biTopic,
        'level': level,
        'referral_url': wixWindow.referrer
    });

    category = clickedCategory;
    updateQueryParams();
}

export function dropdownSort_change(event) {
    sort = event.target.value;
    sendBi(224, {
        'category': 'example',
        'level': level,
        'topic': category,
        'sort_by': sort,
        'referral_url': wixWindow.referrer
    });
    updateQueryParams();
}

export function dropdownLevel_change(event) {
    level = event.target.value;
    sendBi(195, {
        'category': 'example',
        'level': level,
        'topic': category,
        'referral_url': wixWindow.referrer
    });
    updateQueryParams();
}

let debounceTimer;
export function inputSearch_keyPress(event) {
    if (debounceTimer) {
        clearTimeout(debounceTimer);
        debounceTimer = undefined;
    }
    debounceTimer = setTimeout(() => {
        filterByText($w('#inputSearch').value);
        if ($w('#inputSearch').value !== '') {
            hideSearchIcon();
        } else {
            showSearchIcon();
        }
    }, 1200);
}

let lastFilterSearch;
async function filterByText(input) {
    if (lastFilterSearch !== input) {
        search = input;
        updateQueryParams();
        lastFilterSearch = search;
    }
}

export function buttonSearch_click(event) {
    search = $w('#inputSearch').value;
    updateQueryParams();
}

export function buttonClear_click(event) {
    search = '';
    $w('#inputSearch').value = '';
    updateQueryParams();
    showSearchIcon();
}

function hideSearchIcon() {
    $w('#buttonSearch').hide();
    setTimeout(function () {
        $w('#buttonClear').show();
    }, 800);
}

function showSearchIcon() {
    $w('#buttonSearch').show();
    $w('#buttonClear').hide();
}

function paginationOnReadyRepeater($item, itemData, index) {
    // BASEURL CHANGE Fix
    // const href = itemData.isCurrentPage ? itemData.pageNumber : `<a href='/examples/${itemData.link}'>${itemData.pageNumber}</a>`;
    // const href = itemData.isCurrentPage ? itemData.pageNumber : `<a href='/${itemData.link}'>${itemData.pageNumber}</a>`;
    const href = `<a target="_self" href='https://www.wix.com/velo/${itemData.link}'>${itemData.pageNumber}</a>`;
    $item('#paginationItem').html = `<span style='font-size:16px;color:${itemData.isCurrentPage ? BLACK : GREY}'>${href}</span>`;
    // console.log(`<span style='font-size:16px;color:${itemData.isCurrentPage ? BLACK : GREY}'>${href}</span>`);
}

function examplesOnReadyRepeater($item, itemData, index) {
    $item('#exampleImage').src = itemData.thumbnail;
    $item('#exampleImage').tooltip = itemData.title;
    $item('#exampleImage').alt = itemData.title;
    const url = itemData.external ? itemData.siteUrl : '/velo' + itemData.siteUrl;
    $item('#exampleTitle').html = `<a href=${url} target='_self'><h2 style='font-family:madefor-display-bold,helveticaneuew01-65medi,helveticaneuew02-65medi,helveticaneuew10-65medi,sans-serif; font-size: 16px;'>${itemData.title}</h2></a>`;
    $item('#exampleDescription').text = itemData.description;
    $item('#exampleLevelIcon').src = itemData.level.icon;
    $item('#exampleLevelIcon').tooltip = itemData.level.title;
    $item('#exampleLevelText').text = itemData.level.caption;

    if (itemData.package) {
        $item('#veloPackage').show();
    }

    if (itemData.credit) {

        $item('#exampleCreditImage').src = itemData.credit.picture;
        $item('#exampleCreditImage').target = '_blank';
        $item('#exampleCreditImage').link = itemData.credit.url;
        $item('#exampleCreditName').html = `<a href=${itemData.credit.url} target='_blank'><p style='font-family:madefor-display,helveticaneuew01-65medi,helveticaneuew02-65medi,helveticaneuew10-65medi,sans-serif; font-size: 14px;'>${itemData.credit.title}</p></a>`;
        $item('#by').html = `<a href=${itemData.credit.url} target='_blank'><p style='font-family:madefor-display,helveticaneuew01-65medi,helveticaneuew02-65medi,helveticaneuew10-65medi,sans-serif; font-size: 14px; color:#9C9C9C;'>by</p></a>`;

        $item('#exampleCreditContainer').onClick(async () => {
            const biObj1 = {
                category: 'example',
                example_name: itemData.title,
                page_name: 'main_examples_page',
                link_type: 'user_credit_link',
                topic: itemData.category.title,
                level: itemData.level.title,
                related_link: itemData.credit.url,
                referral_url: wixWindow.referrer
            };
            sendBi(199, biObj1);
        })

        $item('#exampleCreditContainer').show();
    } else {
        $item('#exampleCreditContainer').hide();
    }

    // computing views using kiloviews
    let viewsNum, viewStr;
    viewsNum = itemData.exampleViews.views;

    if (viewsNum > 999) {
        viewStr = Math.round(viewsNum / 1000).toString() + 'K';
    } else {
        viewStr = viewsNum.toString();
    }
    $item('#exampleViews').text = viewStr;

    let exampleDate = itemData.date.getTime();
    if (exampleDate + 45 * 24 * 60 * 60 * 1000 > today) {
        $item('#exampleNew').src = 'https://static.wixstatic.com/media/12d367_bc890e6aa1b1449693f021c6bf190bd1~mv2.png';
        $item('#exampleNew').show();
    }

    $item('#exampleImage').onClick(() => navigateToExample(itemData.siteUrl));
    $item('#exampleTitle').onClick(() => navigateToExample(itemData.siteUrl));
    $item('#exampleDescription').onClick(() => navigateToExample(itemData.siteUrl));
}